import React from 'react';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { useCallbackRef } from '../hooks';
import Dialog from '../dialogs/components/Dialog';
import LocationAgencyForm from './LocationAgencyForm';
import DialogFormActions from '../dialogs/components/DialogFormActions';
import { IdPropType } from '../../proptypes/basic';

const LocationAgencyDialog = ({onClose, locationId, agencyId}) => {
    const ref = useCallbackRef();
   
    return (
        <Dialog fullWidth maxWidth="md">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Konfiguration Agentur</DialogTitle>

            <DialogContent>
                <LocationAgencyForm 
                    locationId={locationId}
                    agencyId={agencyId}
                    onDone={onClose}
                    submitRef={ref}
                />
            </DialogContent>

            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

LocationAgencyDialog.propTypes = {
    locationId: IdPropType,
    agencyId: IdPropType,
};

LocationAgencyDialog.defaultProps = {
    locationId: null,
    agencyId: null,
};

export default LocationAgencyDialog;
